import React from 'react';
import { GetUserFiltered_getUserFiltered as User } from '../../../types/schemaTypes';
import './UserItem.scss';

interface Option {
    id: number | string;
    name: string | number;
}

interface UserItemProps {
    user: User;
    options: Option[];
    index: number;
    canEditUsers: boolean;
    onEditClick: (user: User) => void;
}

const UsersItem = ({ user, options, index, onEditClick, canEditUsers }: UserItemProps): React.ReactElement => {
    const { name, emailAddress, roleId, isActive } = user;
    const isOdd = index % 2 == 1;
    const containerStyle = `UsersItem-Bottom-Container ${!isOdd && 'UsersItem-Bottom-Container-With-Background'}`;

    const option = options.find(element => element.id == roleId);

    const role: Option = option ? option : { id: 0, name: '<None>' };

    return (
        <div className={containerStyle}>
            <div className="UsersItem-List-Header">{name}</div>
            <div className="UsersItem-List-Header">{emailAddress}</div>
            <div className="UsersItem-List-Header">{role.name}</div>
            <div className="UsersItem-List-Header">{isActive ? 'Active' : 'Inactive'}</div>
            <div
                className={` ${canEditUsers ? 'UsersItem-Edit-Container' : 'UsersItem-Edit-Container-Disable'}`}
                onClick={() => onEditClick(user)}
            >
                {' '}
                {canEditUsers && (
                    <React.Fragment>
                        <i className="material-icons UsersItem-Icon">edit</i>
                        <span className="UsersItem-Link">Edit</span>
                    </React.Fragment>
                )}
            </div>
        </div>
    );
};

export default UsersItem;

